import { Divider, PageHeadline } from 'components/elements';
import { useFind } from 'components/hooks';
import { ReadOnly } from 'components/modules';
import fp from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import { useMount } from 'react-use';
import { IReadOnlyResource } from 'services/resources/catalogs/types.d';
import { VunerableActivityResources } from 'services/resources/catalogs/vulnerable-activity';

export const VulnerableActivityPage: React.FC = (): JSX.Element => {
  const [state, onFind] = useFind<IReadOnlyResource>(
    VunerableActivityResources,
  );

  const { t } = useTranslation('common');

  useMount(() => onFind());

  return (
    <>
      <PageHeadline
        quote={t('page.read-only.quote')}
        title={t('page.vulnerable-activity.title')}
      />

      <Divider />

      <ReadOnly data={fp.get(['value', 'results'])(state)} m={8} />
    </>
  );
};
